import React, { useEffect, useState } from 'react'
import { motion } from 'motion/react'

export default function AnimatedChecklist() {
  const [cycle, setCycle] = useState(0)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setCycle((value) => value + 1)
    }, 3200)

    return () => window.clearTimeout(timeoutId)
  }, [cycle])

  return (
    <div className="h-14 w-14">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Paper / Clipboard Background */}
        <rect
          x="10"
          y="10"
          width="80"
          height="80"
          rx="12"
          fill="white"
          stroke="#6D6D6D"
          strokeWidth="4"
        />

        <motion.g key={cycle}>
          {/* Item 1 - Unchecked */}
          {/* Checkbox border */}
          <motion.rect
            x="24"
            y="26"
            width="12"
            height="12"
            rx="3"
            stroke="#6D6D6D"
            strokeWidth="2.5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.35, ease: 'easeOut' }}
          />
          {/* Text line */}
          <motion.line
            x1="46"
            y1="32"
            x2="76"
            y2="32"
            stroke="#6D6D6D"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ delay: 0.36, duration: 0.28, ease: 'easeOut' }}
          />

          {/* Item 2 - The Checked Item */}
          {/* Green Checkbox Fill */}
          <motion.rect
            x="24"
            y="46"
            width="12"
            height="12"
            rx="3"
            fill="#1C6F29"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{
              delay: 0.5,
              duration: 0.38,
              type: 'spring',
              stiffness: 300,
              damping: 20,
            }}
          />
          {/* White Checkmark */}
          <motion.path
            d="M27.5 52 L30 54.5 L34.5 48.5"
            stroke="white"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 0.76, duration: 0.22, ease: 'easeOut' }}
          />
          {/* Text line (darker to show it's active/completed) */}
          <motion.line
            x1="46"
            y1="52"
            x2="76"
            y2="52"
            stroke="#6D6D6D"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ delay: 0.56, duration: 0.28, ease: 'easeOut' }}
          />

          {/* Item 3 - Unchecked */}
          {/* Checkbox border */}
          <motion.rect
            x="24"
            y="66"
            width="12"
            height="12"
            rx="3"
            stroke="#6D6D6D"
            strokeWidth="2.5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.74, duration: 0.35, ease: 'easeOut' }}
          />
          {/* Text line (shorter) */}
          <motion.line
            x1="46"
            y1="72"
            x2="76"
            y2="72"
            stroke="#6D6D6D"
            strokeWidth="4"
            strokeLinecap="round"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ delay: 0.82, duration: 0.25, ease: 'easeOut' }}
          />
        </motion.g>
      </svg>
    </div>
  )
}
